import { AfterViewInit, Component, ContentChild, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';

import { Password } from 'primeng/password';

import { SummitIdObject } from '@summit/models';

import { NgTemplateOutlet } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { DividerModule } from 'primeng/divider';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { PasswordModule } from 'primeng/password';
import { SummitControl } from '../../models';
import { SFormErrorInputComponent } from '../s-form-error-input';
@Component({
  selector: 's-form-input-password',
  templateUrl: './s-form-input-password.component.html',
  styleUrls: ['./s-form-input-password.component.scss'],
  standalone: true,
  imports: [
    SFormErrorInputComponent,
    FloatLabelModule,
    InputGroupModule,
    InputGroupAddonModule,
    ReactiveFormsModule,
    DividerModule,
    PasswordModule,
    NgTemplateOutlet
  ]
})
export class SFormInputPasswordComponent<T extends SummitIdObject>
  extends SummitControl<T>
  implements OnInit, AfterViewInit
{
  @Input() showUnhide = true;
  @Input() showFeedback;
  @Input() styleClass: string;

  hide = true;

  //added as a workaround for autocomplete tag
  @ViewChild('pwdInput', { static: false }) pwdInput: Password;
  @ContentChild('prefix') prefix: TemplateRef<unknown>;
  @ContentChild('suffix') suffix: TemplateRef<unknown>;

  // myGroup: any;

  override ngOnInit() {
    super.ngOnInit();
    if (this.showFeedback == undefined || this.showFeedback == null) {
      if (this.autocomplete?.toLocaleLowerCase().includes('new-password')) this.showFeedback ??= true;
      else if (
        this.autocomplete?.toLocaleLowerCase().includes('current-password') ||
        this.autocomplete?.toLocaleLowerCase() == 'off'
      )
        this.showFeedback ??= false;
      else this.showFeedback ??= true;
    }
  }

  ngAfterViewInit(): void {
    if (this.pwdInput) {
      this.pwdInput.input.nativeElement.autocomplete = this.autocomplete;
      this.pwdInput.input.nativeElement.name = this.fieldName;
    }
  }

  get value(): string {
    return this.form.get(this.fieldName ?? '')?.value;
  }
}
